export * from './hms.service';



// WEBPACK FOOTER //
// ./src/shared/index.ts